// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Mwyj","danger":"Button_danger__2lYZ2","plainButton":"Button_plainButton__1tW9n"};